import React, { FC } from 'react';
import { Box, Text, Heading, Button } from '@wix/design-system';
import BriefPromoGif from '@components/Images/brief-promo/brief-promo-card-gif.gif';
import { briefPromoCardDataHooks } from './BriefPromoCard.dataHooks';
import { useBriefPromoCard } from './useBriefPromoCard';
import s from './BriefPromoCard.module.scss';

const BriefPromoCardDesktop: FC = () => {
  const { t, matchURL, handleCtaClick } = useBriefPromoCard();

  return (
    <Box
      direction="vertical"
      backgroundColor="#fff"
      height="100%"
      border="1px solid #dfe5eb"
      borderRadius="8px"
      className={s.container}
      dataHook={briefPromoCardDataHooks.boxContainer()}
      verticalAlign="middle"
    >
      <Box align="center" className={s.imageSection}>
        <img
          src={BriefPromoGif.src}
          className={s.gif}
          width={146}
          height={179}
          alt=""
          data-hook={briefPromoCardDataHooks.gif()}
        />
      </Box>

      <Box
        direction="vertical"
        align="center"
        textAlign="center"
        padding="24px 42px 18px"
      >
        <Heading size="medium" as="h3">
          {t('explore-page.brief-promo-card.title')}
        </Heading>
        <Box marginTop="6px">
          <Text size="small" weight="thin" secondary>
            {t('explore-page.brief-promo-card.subtitle')}
          </Text>
        </Box>
        <Box marginTop="18px">
          <Button
            skin="standard"
            as="a"
            size="small"
            href={matchURL}
            target="_blank"
            dataHook={briefPromoCardDataHooks.cta()}
            onClick={handleCtaClick}
          >
            {t('explore-page.brief-promo-card.cta')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default BriefPromoCardDesktop;
